/* eslint-disable @typescript-eslint/no-explicit-any */ import { T } from "@supersig/validate";
import { idValidator } from "../misc/id-validator";
/** @public */ export const localizationProviderLanguageIdValidator = idValidator("localization_provider_language");
/** @public */ export function createLocalizationProviderLanguageValidator(type, props, meta) {
    return T.object({
        id: localizationProviderLanguageIdValidator,
        typeName: T.literal("localization_provider_language"),
        type: T.literal(type),
        props: props ? T.object(props) : T.jsonValue,
        meta: meta ? T.object(meta) : T.jsonValue,
        locale: T.string,
        displayName: T.string,
        providerLanguageId: T.string,
        isRTL: T.boolean
    });
}
